const en = {
    aboutProject: "About the Project",
    publicationRules: "Publication Rules",
    privacyPolicy: "Privacy Policy",
    reportUser: "Report a User",
    reportBug: "Report a Bug",
    suggestImprovements: "Suggest App Improvements",
    admin: "Admin",
    logout: "Logout",
}

const rus = {
      aboutProject: "О Проекте",
      publicationRules: "Правила размещения объявлений",
      privacyPolicy: "Политика обработки персональных данных",
      reportUser: "Пожаловаться на пользователя",
      reportBug: "Сообщить об ошибке в работе приложения",
      suggestImprovements: "Предложить улучшения для приложения",
      admin: "Админ",
      logout: "Выйти из приложения",
}

const hebrew = {
      aboutProject: "על הפרויקט",
      publicationRules: "כללי פרסום",
      privacyPolicy: "מדיניות פרטיות",
      reportUser: "להגיש תלונה על משתמש",
      reportBug: "לדווח על תקלה באפליקציה",
      suggestImprovements: "להציע שיפורים לאפליקציה",
      admin: "מנהל",
      logout: "התנתק",
}

const choose = { en, rus, hebrew };

export default choose;